import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import {
  endpointEnum,
  makeApiRequestCached,
} from '../../../services/rest/makeAPIRequest';

export interface IHubspotVisitorIdentificationAPIProps {
  user: any;
}

export const HubspotVisitorIdentificationAPI = ({
  user,
}: IHubspotVisitorIdentificationAPIProps) => {
  (window as any).hsConversationsSettings = {
    loadImmediately: false,
  };

  if (!user || !user.email || !user.fname || !user.lname) return null;

  const [
    _hubspotIdentificationCached,
    hubspotIdentificationLoadable,
    _setRefetchToggleForHubspotIdentification,
  ] = makeApiRequestCached(
    {
      endpoint: endpointEnum.PROXY_HUBSPOT_VISITOR_IDENTIFICATION_API,
      payloadJsonString: JSON.stringify({
        call: methodNameEnum.PROXY_HUBSPOT_VISITOR_IDENTIFICATION_API,
        email: user.email,
        firstName: user.fname,
        lastName: user.lname,
      }),
    },
    (loadable, cached) => loadable.contents?.response?.data ?? cached.current
  );

  const data = hubspotIdentificationLoadable?.contents?.response?.data;

  if (data?.email) {
    (window as any).hsConversationsSettings.identificationEmail = data?.email;
  }

  if (data?.token) {
    (window as any).hsConversationsSettings.identificationToken = data?.token;
  }

  const onHubspotConversationsReady = () => {
    if (
      typeof (window as any).HubSpotConversations?.widget?.load === 'function'
    ) {
      (window as any).HubSpotConversations.widget.load();
    }
  };

  if ((window as any).HubSpotConversations) {
    onHubspotConversationsReady();
  } else {
    (window as any).hsConversationsOnReady = [onHubspotConversationsReady];
  }

  return null;
};
